module.exports = __webpack_public_path__ + "media/GothaProLig.aab7d221.otf";


//////////////////
// WEBPACK FOOTER
// ./fonts/GothaProLig.otf
// module id = 97
// module chunks = 9